import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { MunicipiosRequest, Types } from './types';

// ACTIONS
import { municipiosSuccess, municipiosFailure } from './actions';

function* municipiosRequest(request: ReducerAction) {
	const { payload }: { payload: MunicipiosRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`dominios-crm/${CHANNEL}/municipios`,
		payload,
	);

	if (response.status === 200) {
		yield put(municipiosSuccess(response));
	} else {
		yield put(municipiosFailure(response));
	}
}

export default all([takeLatest(Types.MUNICIPIOS_REQUEST, municipiosRequest)]);
